<div class=" h-100 t2 c-primary-gray-900" fxLayout="column" fxLayoutAlign="start start">
    <mat-expansion-panel class="w-100">
        <mat-expansion-panel-header class="w-100"
                                    fxLayout="start start">
            <mat-panel-title class="no-wrap t2-semi-bold"> {{ 'i18n_af_labelIncidentCommonDetails' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="common-info-container">
            <div class="c-primary-gray-600">{{ 'i18n_af_fieldLabelFraudType' | translate }}</div>
            <div>{{ incident.fraud_type }}</div>
            <div class="c-primary-gray-600">{{ 'i18n_af_fieldLabelBasedOn' | translate }}</div>
            <div>{{ incident.based_on }}</div>
            <div class="c-primary-gray-600">{{ 'i18n_af_fieldLabelDescription' | translate }}</div>
            <div>{{ incident.description }}</div>
        </div>
    </mat-expansion-panel>
    @if (showAmountDetails) {
        <mat-expansion-panel class="w-100 mt-12">
            <mat-expansion-panel-header class="w-100"
                                        fxLayout="start start">
                <mat-panel-title class="no-wrap t2-semi-bold"> {{ 'i18n_af_labelIncidentAmountDetails' | translate }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="w-100" fxLayout="row" fxLayoutAlign="space-between start">
                <div fxLayout="column" fxLayoutAlign="space-between start">
                    <div class="c-primary-gray-600 pre-wrap">{{ 'i18n_af_fieldLabelAmountLossCredit' | translate }}</div>
                    <div class="mt-8">
                        {{ Number(incident.amount_loss_credit) | tiynTenge | numberTriplesFormat }} {{ incident.currency_amount_loss_credit }}
                    </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="space-between start">
                    <div class="c-primary-gray-600 pre-wrap">{{ 'i18n_af_fieldLabelAmountLossOwn' | translate }}</div>
                    <div class="mt-8">
                        {{ Number(incident.amount_loss_own) | tiynTenge | numberTriplesFormat }} {{ incident.currency_amount_loss_own }}
                    </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="space-between start">
                    <div class="c-primary-gray-600 pre-wrap">{{ 'i18n_af_fieldLabelAmountSaveCredit' | translate }}</div>
                    <div class="mt-8">
                        {{ Number(incident.amount_save_credit) | tiynTenge | numberTriplesFormat }} {{ incident.currency_amount_save_credit }}
                    </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="space-between start">
                    <div class="c-primary-gray-600 pre-wrap">{{ 'i18n_af_fieldLabelAmountSaveOwn' | translate }}</div>
                    <div class="mt-8">
                        {{ Number(incident.amount_save_own) | tiynTenge | numberTriplesFormat }} {{ incident.currency_amount_save_own }}
                    </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="space-between start">
                    <div class="c-primary-gray-600 pre-wrap">{{ 'i18n_af_fieldLabelAmountTotal' | translate }}</div>
                    <div class="mt-8">{{ Number(incident.amount) | tiynTenge | numberTriplesFormat }}</div>
                </div>
            </div>
        </mat-expansion-panel>
    }
</div>
